<template>
  <div>
    <!--已报名 未填写密码-->
    <div v-if="isSign && current===1">
      <el-result icon="info" title="请联系教师" subTitle="请联系教师获取修改密码">
        <div slot="extra" class="difcc">
          <div style="width: 36rem;" class="mrBtm20">
            <el-input type="password" placeholder="请输入修改密码" v-model="password2"></el-input>
          </div>
          <el-button type="primary" @click="judge()">确认</el-button>
        </div>
      </el-result>
    </div>
    <!--已报名 已填写密码-->
    <div v-show="isSign && current===2" class="pdTop10">
      <div class="tct fs24" style="color: #337ab7">填写基本信息</div>
      <!--填写基本信息和确认信息-->
      <div v-if="active===1 || active===2" style="margin-top: 4rem;">
        <!--填写基本信息-->
        <div class="warp">
          <h2 class="warp_title" style="font-size: 16px;">修改信息</h2>
          <el-row>
            <!--姓名-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">姓名</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入姓名" :disabled="is_disabled" v-model="name"></el-input>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(限２０个汉字，中不留空，找不到的汉字以汉语拼音（半角大写字母）代替；少数民族考生姓名中若含有点请复制使用“·”)
              </div>
            </el-col>
            <!--民族-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">民族</span>
              </div>
              <div class="mrLft20 w30">
                <el-select v-model="nation" :disabled="is_disabled" style="width: 100%;">
                  <el-option
                      v-for="(item,index) in nations" :key="index"
                      :label="item"
                      :value="item"
                  ></el-option>
                </el-select>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(少数民族执行加分照顾政策请咨询当地县级招生办公室)
              </div>
            </el-col>
            <!--性别-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">性别</span>
              </div>
              <div class="mrLft20 w30">
                <el-radio v-model="gender" label="1" :disabled="is_disabled">男</el-radio>
                <el-radio v-model="gender" label="2" :disabled="is_disabled">女</el-radio>
              </div>
            </el-col>
            <!--出生日期-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">出生日期</span>
              </div>
              <div class="mrLft20 w30">
                <el-date-picker
                    style="width: 100%;"
                    :disabled="is_disabled"
                    v-model="birth"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(出生日期须与身份证一致，填写格式为：YYYY-MM-DD，截止到2021年12月31日未满18周岁考生确认时需提供高中同等学力毕业证书)
              </div>
            </el-col>
            <!--是否工作-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">是否工作</span>
              </div>
              <div class="mrLft20 w30">
                <el-radio v-model="is_work" label="1" :disabled="is_disabled">是</el-radio>
                <el-radio v-model="is_work" label="0" :disabled="is_disabled">否</el-radio>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(少数民族执行加分照顾政策请咨询当地县级招生办公室)
              </div>
            </el-col>
            <!--身份证号-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">身份证号</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入身份证号" maxlength="18" v-model="number" :disabled="is_disabled"></el-input>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--填写联系方式-->
        <div class="warp mrTop30">
          <h2 class="warp_title" style="font-size: 16px;">填写联系方式</h2>
          <el-row>
            <!--联系电话-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">接受短信手机号码</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入联系电话" v-model="tel" :disabled="is_disabled"></el-input>
              </div>
              <!--<div class="mrLft20 w30">-->
              <!--  <span class="text-red">*</span>(限２０个汉字，中不留空，找不到的汉字以汉语拼音（半角大写字母）代替；少数民族考生姓名中若含有点请复制使用“·”)-->
              <!--</div>-->
            </el-col>
            <!--户籍地址-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">户籍地址</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入户籍地址" v-model="huji" :disabled="is_disabled"></el-input>
              </div>
            </el-col>
            <!--邮件地址-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">电子邮箱E-MAIL</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="电子邮箱E-MAIL" v-model="youjian" :disabled="is_disabled"></el-input>
              </div>
              <div class="mrLft20 w30">
                (没有可不填写)
              </div>
            </el-col>
            <!--邮寄地址-->
            <el-col :span="24" :xs="24" class="dif mrTop10">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">通知书邮寄地址</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入邮寄地址" v-model="youji" type="textarea" rows="5" :disabled="is_disabled"></el-input>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(不超过32个汉字)
              </div>
            </el-col>
          </el-row>
        </div>
        <!--填写报考志愿-->
        <div class="warp mrTop30" v-if="false">
          <h2 class="warp_title" style="font-size: 16px;">填写报考志愿</h2>
          <el-row>
            <!--目前学历-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">请选择文化程度</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;" v-model="nowXueli" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in nowXueliArr"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考学历-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">请选择报考层次</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;" v-model="applyXueli" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in applyXueliArr"
                      :key="item.value"
                      :disabled="item.disabled"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(必须先选择文化程度)
              </div>
            </el-col>
            <!--报考学科-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">报考学科</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;"
                           @change="changeXk"
                           v-model="applyXueke" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in applyXuekeArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考专业-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">报考专业</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;" v-model="applyZhuanye" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in applyZhuanyeArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <!--报考学校-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">报考学校</span>
              </div>
              <div class="mrLft20 w30">
                <el-select style="width: 100%;" v-model="applySchool" placeholder="请选择" :disabled="is_disabled">
                  <el-option
                      v-for="item in schoolArr"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--填写报名确认点-->
        <div class="warp mrTop30">
          <h2 class="warp_title" style="font-size: 16px;">填写报名确认点</h2>
          <el-row>
            <!--考试地区-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">考试地区</span>
              </div>
              <div class="mrLft20 w30">
                <el-cascader
                    style="width: 100%;"
                    size="large"
                    :options="options"
                    v-model="area"
                    :disabled="is_disabled"
                    @change="setArea">
                </el-cascader>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>(考生参加考试地区)
              </div>
            </el-col>
            <!--确认地点-->
            <el-col :span="24" :xs="24" style="height: 80px;" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">确认地点</span>
              </div>
              <div class="mrLft20 w30">
                <el-cascader
                    style="width: 100%;"
                    size="large"
                    :options="options"
                    v-model="confirmAddress"
                    :disabled="is_disabled"
                    @change="setConfirm">
                </el-cascader>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>审查/照相/报名信息确认地点，报名成功后不允许修改
              </div>
            </el-col>
            <!--登录密码-->
            <el-col :span="24" :xs="24" style="height: 80px;" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">登录密码</span>
              </div>
              <div class="mrLft20 w30">
                <el-input type="password" placeholder="请输入登录密码，限50字符" maxlength="50" v-model="password" :disabled="is_disabled"></el-input>
              </div>
              <div class="mrLft20 w30">
                <span class="text-red">*</span>请记住密码，查询录取名单时用到
              </div>
            </el-col>
            <!--指导老师-->
            <el-col :span="24" :xs="24" class="dif alc item">
              <div class="fs16  w20 trt">
                <span style="color: #EE2352">*</span>
                <span class="col101010" style="font-size: 14px;">指导老师</span>
              </div>
              <div class="mrLft20 w30">
                <el-input placeholder="请输入指导老师姓名" :disabled="is_disabled" v-model="teacherName"></el-input>
              </div>
            </el-col>
          </el-row>
        </div>
        <!--重置和下一步-->
        <div class="mrTop30 button_warp">
          <!--<el-col :span="12" :xs="24" class="difcac">-->
          <!--  <div class="difcac button2 pointer" @click="reset()" v-if="active===1">重置</div>-->
          <!--  <div class="difcac button2 " style="opacity: 0;" v-if="active===2">上一步</div>-->
          <!--</el-col>-->
          <el-col :span="24" :xs="24" class="difcac">
            <div class="difcac button1 pointer" @click="submit()" v-if="active===1">提交信息</div>
            <div class="difcac button1 pointer" v-if="active===2" @click="showPay()">提交</div>
          </el-col>
        </div>
      </div>
    </div>
    <!--未报名-->
    <div v-if="!isSign" class="difcc" style="height: 65vh;">
      <el-result icon="info" title="尚未报名" subTitle="点击前往报名">
        <div slot="extra" class="difcc">
          <el-button type="primary" @click="goSign()">去报名</el-button>
        </div>
      </el-result>
    </div>
  </div>
</template>

<script>
import {regionData, CodeToText, TextToCode } from 'element-china-area-data' //地址插件
export default {
  name: "profile",
  data() {
    return {
      password2: '',//修改用密码
      isSign: false,
      current: 1,//
      bid: '',//报名id

      active: 1,//当前步骤
      options: regionData,
      value: '',
      nations: ["汉族","蒙古族","回族","藏族","维吾尔族","苗族","彝族","壮族","布依族","朝鲜族","满族","侗族","瑶族","白族","土家族",
        "哈尼族","哈萨克族","傣族","黎族","傈僳族","佤族","畲族","高山族","拉祜族","水族","东乡族","纳西族","景颇族","柯尔克孜族",
        "土族","达斡尔族","仫佬族","羌族","布朗族","撒拉族","毛南族","仡佬族","锡伯族","阿昌族","普米族","塔吉克族","怒族", "乌孜别克族",
        "俄罗斯族","鄂温克族","德昂族","保安族","裕固族","京族","塔塔尔族","独龙族","鄂伦春族","赫哲族","门巴族","珞巴族","基诺族"],
      is_disabled: false,//是否禁用
      name: '',//姓名
      nation: '汉族',//民族
      gender: '1',//性别
      birth: '',//出生日期
      is_work: '1',//是否工作
      number: '',//身份证
      tel: '',//联系电话
      huji: '',//户籍地址
      youjian: '',//邮件地址
      youji: '',//邮寄地址
      nowXueli: '',//目前学历
      applyXueli: '',//报考学历
      applyZhuanye: '',//报考专业
      applyXueke: '',//报考学科
      xk: '',
      applySchool: '',//报考学校
      area: '',//考试地区
      area2: '',//考试地区
      confirmAddress: '',//确认地点
      confirmAddress2: '',//确认地点
      password: '',//登录密码
      teacherName: '',//指导老师姓名
      payImg: '',

      //滚动动画
      el: null,
      container: null,
      visible: false,

      //选择项
      nowXueliArr: [ //当前学历
        {value: '小学',label: '小学'},
        {value: '初中',label: '初中'},
        {value: '高中',label: '高中'},
        {value: '专科',label: '专科'},
      ],
      applyXueliArr: [ //报考学历
        {value: 1,label: '高起专',disabled: false},
        {value: 2,label: '高起本',disabled: false},
        {value: 3,label: '专升本',disabled: false},
      ],
      applyZhuanyeArr: [],//报考专业
      applyXuekeArr: [],//报考学科
      schoolArr: [],//报考学校

      //支付图片和金额
      price: '',
      ercode: '',
    }
  },
  methods: {
    judge() { //判断密码是否正确
      this.$axios("POST","/index/judge",{
        id: this.bid,
        password: this.password2
      }).then(res => {
        if(res.code===1) {
          this.current = 2 //进入修改信息页面
        }else {
          this.$alert(res.msg,{type: 'error'})
        }
      })

    },
    goSign() { //去报名
      this.$router.push('/infoCenter/sign').catch(err => err)
    },
    getBaomingInfo(user_id) { //获取报名信息
      this.$axios("POST","/index/bmUser",{user_id: user_id},'加载中')
          .then(res => {
            if(res.code===1) {
              this.name = res.data.name //姓名
              this.nation = res.data.mz //民族
              this.birth = res.data.date_time //生日
              this.is_work = res.data.is_gz //是否工作
              this.gender = res.data.sex //性别
              this.number = res.data.idcard //身份证号
              this.tel = res.data.tel //电话
              this.huji = res.data.address //户籍地址
              this.youjian = res.data.email //邮箱地址
              this.youji = res.data.email_address //邮寄地址
              this.password = res.data.password //登录密码
              this.teacherName = res.data.teacher //老师姓名
              this.area = this.getText(res.data.ks_address) //考试地点
              this.area2 = res.data.ks_address
              this.confirmAddress = this.getText(res.data.qr_address) //确认地点
              this.confirmAddress2 = res.data.qr_address
             }
          })
    },
    getUserInfo() { //获取用户信息
      let user_id = JSON.parse(localStorage.getItem('jiaoyu')).id
      this.$axios("POST","/user/info",{user_id: user_id})
      .then(res => {
        if(res.code===1) {
          if(res.data.baoming_id) {
            this.isSign = true
            this.bid = res.data.baoming_id
            this.getBaomingInfo(res.data.id) //获取报名信息
          }
        }
      })
    },
    submit() { //提交密码
      let data = {
        name: this.name,
        mz: this.nation,
        sex: this.gender,
        is_gz: this.is_work,
        date_time: this.birth,
        idcard: this.number,
        tel: this.tel,
        address: this.huji,
        email: this.youjian,
        email_address: this.youji,
        ks_address: this.area2, //考试地址
        qr_address: this.confirmAddress2, //确认地址
        password: this.password,//登录密码
        teacher: this.teacherName,//老师
        id: this.bid,
      }
      this.$axios("POST","/index/bmEdit",data,'加载中')
      .then(res => {
        if(res.code===1) {
          this.$alert('修改成功',{type: 'success'})
          .then(al => {
            this.$router.push('/infoCenter/check').catch(err => err)
          })
        }else {
          this.$alert(res.msg)
        }
      })
    },
    setArea(e) { //选择考试地区
      let p = CodeToText[e[0]]
      let c = CodeToText[e[1]]
      let a = CodeToText[e[2]]
      this.area2 = `${p},${c},${a}`
    },
    setConfirm(e) { //选择确认地点
      let p = CodeToText[e[0]]
      let c = CodeToText[e[1]]
      let a = CodeToText[e[2]]
      this.confirmAddress2 = `${p},${c},${a}`
    },
    getText(name) { //根据省市区名获取code
      let arr = name.split(',')
      let code1 = TextToCode[arr[0]].code
      let code2 = TextToCode[arr[0]][arr[1]].code
      let code3 = TextToCode[arr[0]][arr[1]][arr[2]].code
      return [code1,code2,code3]
    },
  },
  watch: {
    area(newValue) {
      console.log(newValue);
    },
  },
  created() {
    this.getUserInfo()
  },
}
</script>

<style scoped>
  .bg{
    width: 100%;
    /*background: #00B7A4;*/
  }
  .sign_up{
    width: 80%;
    margin: 0 auto;
    background: #FFFFFF;
  }
  .router{
    padding: 2rem;
    box-sizing: border-box;
  }
  .warp{
    width: 100%;
    background: #E5FFFA;
    box-sizing: border-box;
    padding: 2rem;
  }
  .warp_title{
    color: #00B7A4;
    padding-bottom: 2rem;
    border-bottom: 1px solid #929393;
  }
  .logo_warp{
    position: absolute;
    top: 5rem;
    z-index: 22;
    left: 4rem;
  }
  .site_title{
    font-weight: bold;
    color: #FFFFFF;
    font-size: 4rem;
  }
  .logo_warp img{
    width: 8rem;
    height: 8rem;
    border-radius: 50%;
    background: #FFFFFF;
  }
  .item{
    height: 60px;
    box-sizing: border-box;
  }
  .w70{
    width: 50%;
  }
  .button2{
    width: 80%;
    height: 60px;
    font-size: 16px;
    background: #FFFFFF;
    box-sizing: border-box;
    border: 1px solid #BBBBBB;
    color: #101010;
  }
  .button1{
    width: 80%;
    height: 60px;
    font-size: 16px;
    background: #4eac4e;
    color: #FFFFFF;
  }
  .button_warp{
    height: 120px;
  }
  .code{
    width: 22rem;
    height: 22rem;
    background: #cbcbcb;
    margin-top: 5rem;
    margin-bottom: 3.5rem;
  }
  .upLoad{
    width: 12rem;
    height: 12rem;
    background-color: rgba(0, 0, 0, 0.02);
    cursor: pointer;
  }
  @media (max-width: 768px) {
    .sign_up{
      width: 100%;
    }
    .w70{
      width: 70%;
    }
    .button1{
      margin-top: 10px;
    }
    .button_warp{
      height: 150px;
    }
  }
</style>